module.exports = __webpack_public_path__ + "img/android-app-store-qr-code.97ae793a.png";